import { merge } from 'lodash'
import { Carousel, CarouselProps } from 'primereact/carousel'
import { useResizeListener } from 'primereact/hooks'
import { useEffect, useState } from 'react'

const responsiveOptions = [
  {
    breakpoint: '1800px',
    numVisible: 3,
    numScroll: 1,
  },
  {
    breakpoint: '1200px',
    numVisible: 2,
    numScroll: 1,
  },
  {
    breakpoint: '768px',
    numVisible: 1,
    numScroll: 1,
  },
]

const carouselBtnClassnames =
  'bg-[var(--primary-color)] rounded-full text-white h-10 w-10 lg:h-16 lg:w-16 flex items-center justify-center'

export function CommonTutorialCarousel(props: CarouselProps) {
  const [, setResizeEvt] = useState<{ width: number; height: number }>()

  const [bindWindowResizeListener, unbindWindowResizeListener] = useResizeListener({
    listener: (event) => {
      setResizeEvt({
        width: (event.currentTarget as Window).innerWidth,
        height: (event.currentTarget as Window).innerHeight,
      })
    },
  })

  useEffect(() => {
    bindWindowResizeListener()

    return () => {
      unbindWindowResizeListener()
    }
  }, [bindWindowResizeListener, unbindWindowResizeListener])

  return (
    <div className='mb-1 mt-10'>
      <Carousel
        {...props}
        pt={merge(props.pt, {
          nextButtonIcon: { className: carouselBtnClassnames },
          previousButtonIcon: { className: carouselBtnClassnames },
          indicatorButton: {
            className: 'bg-[var(--primary-color)] h-2 w-2 rounded-full',
          },
        })}
        numVisible={3}
        numScroll={1}
        responsiveOptions={responsiveOptions}
      />
    </div>
  )
}
